module.exports = __webpack_public_path__ + "static/media/Genesis-Tablet-Banner-@2-1476x114.e450239a.jpg";